import React from 'react';
import Warning from 'jsx/elements/messages/Warning';
import Trash from 'jsx/elements/buttons/Trash';
import SearchBox from 'jsx/elements/inputs/SearchBox';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';
import Tooltip from 'jsx/elements/messages/Tooltip';
import { splitSsn } from 'utils/strings';

export default function ExclusionTable({ data, onRemove }) {
  const [show, setShow] = React.useState({ type: 'initial', data: null });
  const [search, setSearch] = React.useState('');
  const { t } = useLocale();

  let filtered = data;
  if (search) {
    const noDash = search.replace('-', '');
    filtered = filtered.filter((e) => {
      const matchSsn = e.payorRegno && e.payorRegno.startsWith(noDash);
      const matchName = e.name && e.name.toLowerCase().includes(search.toLowerCase());
      return matchSsn || matchName;
    });
  }

  function clearShow() {
    setShow({ type: 'initial', data: null });
  }

  return (
    <div>
      <Tooltip id="trashTip" />
      {show.type === 'success' && (
        <Warning
          onClose={clearShow}
          messageType="success"
          messageHeader={t('portfolio_exclusionRemovalModal_removeSuccess_title')}
          messageBody={t(
            'portfolio_exclusionRemovalModal_removeSuccess_body',
            show.data.name,
            splitSsn(show.data.payorRegno)
          )}
        />
      )}

      {show.type === 'error' && (
        <Warning
          onClose={clearShow}
          messageType="alert"
          messageHeader={t('portfolio_exclusionRemovalModal_confirmRemove_header')}
          messageBody={t(
            'portfolio_exclusionRemovalModal_confirmRemove_header',
            show.data.name,
            splitSsn(show.data.payorRegno)
          )}
        />
      )}

      {data.length > 0 && (
        <div className="grid half-spacing-top gutter-bottom">
          <div className="col s1of3">
            <SearchBox
              onChange={(e) => setSearch(e.target.value)}
              placeholder={t('portfolio_exclusion_searchbox_placeholder')}
              value={search}
            />
          </div>
        </div>
      )}
      <div className="table-wrap">
        <table className="table advanced no-vertical-border">
          <colgroup>
            <col width="15%" />
            <col width="60%" />
            <col width="25%" />
          </colgroup>
          <thead>
            <tr>
              <th className="no-right-border no-left-border">
                {t('portfolio_exclusionTable_header_regno')}
              </th>
              <th className="no-right-border no-left-border">
                {t('portfolio_exclusionTable_header_name')}
              </th>
              <th className="text-right no-left-border no-right-border">
                {t('portfolio_exclusionTable_header_remove')}
              </th>
            </tr>
          </thead>
          <tbody className="only-bottom-border">
            {filtered.map((e) => (
              <ExclusionRow customer={e} key={e.payorRegno} onTrash={onRemove} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ExclusionRow({ customer, onTrash }) {
  const { t } = useLocale();
  return (
    <tr>
      <td>{splitSsn(customer.payorRegno) || '-'}</td>
      <td>{customer.name || '-'}</td>
      <td className="text-right">
        <span className="text-18">
          <Trash
            data-for="trashTip"
            data-tip={t('portfolio_exclusionTable_removal_tooltip')}
            onClick={() => onTrash(customer)}
          />
        </span>
      </td>
    </tr>
  );
}
